<template lang="pug">
p(:class="textBodyClass", :style="textBodyStyles", @click="$emit('click')")
    slot {{ text }}
</template>

<script lang="ts">
import Vue from "vue"
export default Vue.extend({
  name: "TextBody",
  props: {
    text: String,
    customClass: { type: String, default: "" },
    large: { type: Boolean, default: false },
    inline: { type: Boolean, default: false },
    fontSize: { type: Number, default: 1 },
    color: { type: String, default: "textColor" },
    looksEditable: { type: Boolean, default: false },
  },
  computed: {
    textBodyStyles(): object {
      let styles = {
        fontSize: `${this.fontSize}rem !important`,
        fontFamily: "system-ui !important",
        color: this.$vuetify.theme.themes.light[this.color]?.toString(),
        display: "",
        lineHeight: "unset",
        marginBottom: "0"
      }
      this.inline && (styles.display = "inline !important")
      if (this.large) {
        styles.fontSize = "1.2rem !important"
        styles.lineHeight = "1.8rem !important"
      }
      return styles
    },
    textBodyClass(): object {
      const classes = {
        [this.customClass]: true,
        "editable": this.looksEditable,
      };
      return classes;
    },
  },
})
</script>

<style scoped>
.editable:hover {
  text-decoration: underline;
  cursor: text;
}
</style>
